import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isEcomCompanyName(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.ECOM_COMPANY_NAME && typeof label === 'string' && typeof value === 'string';
}
function _formatEcomCompanyName(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatEcomCompanyName(submission) {
  if (isEcomCompanyName(submission)) {
    return _formatEcomCompanyName(submission);
  }
  return undefined;
}
//# sourceMappingURL=ecom-company-name-preview.js.map